export default "__VITE_ASSET__CytLcPFC__"